<template>
  <div class="cate">
    <div class="cate-parent flex flex-row flex-wrap pointer">
      <div
        v-for="(item, index) in allCates"
        :key="index"
        class="cate-item parent"
        :class="{
          active: item.id === currentParent,
        }"
        @click="pItemClick(item.id)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="cate-child flex flex-row flex-wrap pointer">
      <div
        v-for="(item, index) in childItem"
        :key="index"
        class="cate-item child"
        :class="{
          active: item.id === currentChild,
        }"
        @click="cItemClick(item.id)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
<script>
import { trainCate } from "@/api/onlineTrain";
export default {
  data() {
    return {
      allCates: [],
      childItem: [],
      currentParent: null,
      currentChild: null,
    };
  },
  async created() {
    await this.getAllCate();
  },
  methods: {
    async getAllCate() {
      this.loading = true;
      const data = await this.$axios.get(trainCate).finally(() => {
        this.loading = false;
      });
      this.allCates = data;
      this.pItemClick(data[0].id);
    },
    pItemClick(id) {
      this.currentParent = id;
      this.currentChild = null;
      this.childItem = this.allCates.find((el) => el.id == id).childTree;
      this.$emit("typeChange", id);
    },
    cItemClick(id) {
      this.currentChild = id;
      this.$emit("typeChange", id);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.cate {
  background: white;
  padding: 15px 15px 5px 15px;
  &-item {
    margin-right: 20px;
    margin-bottom: 10px;
    // font-size: 12px;
    &:hover,
    &.active {
      color: $theme-color;
    }
    &.parent {
      font-size: 15px;
      font-weight: bold;
    }
    &.child {
      border: 1px solid white;
      padding: 3px 10px;
    }
    &.child.active {
      border: 1px solid $theme-color;
      border-radius: 15px;
    }
  }
  &-parent {
    margin-bottom: 5px;
    padding-left: 10px;
  }
}
</style>
